import { render } from "./LogementDetailsV2.vue?vue&type=template&id=8b6613fe&scoped=true"
import script from "./LogementDetailsV2.vue?vue&type=script&lang=js"
export * from "./LogementDetailsV2.vue?vue&type=script&lang=js"

import "./LogementDetailsV2.vue?vue&type=style&index=0&id=8b6613fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6613fe"]])

export default __exports__